/**
 * Huroof SPA entry point.
 *
 * Mounts the Preact app, imports global styles, and registers the
 * service worker once the app has painted.
 */

import { render } from 'preact';
import { App } from './app';
import './styles/index.css';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

render(<App />, root);

// Register service worker in production only — Vite's dev server serves
// a `sw.js` placeholder that would interfere with HMR if cached.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('[huroof] SW registration failed:', err));
  });
}
